import { RegenerateTokenDto } from '../../dto/regeneratetoken/regeneratetokendto';
import { APIResponse, APIResponseDtoImpl } from '../apiresponse';

export interface RegenerateTokenResponse extends APIResponse 
{
    getRegenerateTokenDto(): RegenerateTokenDto;
}

export class RegenerateTokenResponseDtoImpl extends APIResponseDtoImpl implements RegenerateTokenResponse 
{
    private regenerateTokenResponseDto : RegenerateTokenDto;

    getRegenerateTokenDto(): RegenerateTokenDto
    {
        return this.regenerateTokenResponseDto;
    }
    setRegenerateTokenDto(regenerateTokenResponseDto: RegenerateTokenDto)
    {
        this.regenerateTokenResponseDto = regenerateTokenResponseDto;
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/regeneratetoken/regeneratetokenresponse.tsx